export default function(fields, id) {
  return {
    ...fields,
    activity: {
      id,
    },
    duration: fields.duration * 60,
    fileUrls: fields && fields.fileUrls && fields.fileUrls.map(item => item.url),
    discriminator: undefined,
    helpers: undefined,
  }
}
